module.exports = __webpack_public_path__ + "fonts/vizztons.00d9e90.woff";